/**
 * Demo-time anchors for the platform demo fixtures.
 *
 * `search.ts`'s EP-PROCESS fixture places each host's process chain a fixed
 * number of minutes before "now" so a signal's ±15 min deep-panel window
 * finds it. The signal storylines that point at these chains live with the
 * VANTAGE product (`signals-demo.ts`, which core-shell may never import —
 * rule 11), so the anchors are defined here as the platform copy.
 *
 * This is the CANONICAL copy: the vantage storylines fixture
 * (`@bloo-team/product-vantage`, `lib/signals-demo.ts`) imports these from the
 * `@bloo-team/core-shell` barrel since its E6 extraction — one clock, no twin.
 */
export const DEMO_NOW = Date.now()

/**
 * Where each authored storyline's endpoint chain sits in time (minutes
 * before DEMO_NOW). Keep in sync with the vantage `storylines()` fixture,
 * which reads these values.
 */
export const DEMO_CHAIN_AGO: Record<string, number> = {
  'fin-srv-07': 40,
  'eng-ws-22': 26 * 60,
  'eng-ws-31': 25 * 60 + 40,
  'build-agent-13': 6 * 24 * 60 - 15,
  'ws-104': 3 * 60,
}
